import {ServiceBase} from '../../../ServiceBase';
import {IDeepLinkParserService} from './deep-link-parser.service.interface';
import {IDeepLinkParser} from './parsers/deep-link-parser.interface';
import {DeepLinkJsonObjectParser} from './parsers/deep-link-json-object-parser/deep-link-json-object-parser';
import {Check} from '@sparkware/app-utils';
import {decodeUriComponentRecursive} from '../../../../../utils/url-utils';
import {DEEP_LINK_HASH_PARAM} from "../../deeplink-consts";



export const DEEP_LINK_QUERY_PARAM = 'deeplink';
const SPECIFIC_NAVIGATION = 'specificNavigation';
const SPECIFIC_NAVIGATION_PARAM = SPECIFIC_NAVIGATION + '=';


export class DeepLinkParserService extends ServiceBase implements IDeepLinkParserService {
  getParserFromCurrentRoute(): IDeepLinkParser | null {

    if(!this.services.location.currentUri) {
      return null;
    }

    let deepLinkJson = this._extractDeepLinkJsonFromFragment();


    if(!deepLinkJson) {
      deepLinkJson = this._extractDeepLinkJsonFromDeepLinkQueryParam();
    }

    let isDeepLinkFromSpecificNavigation = false;
    if(!deepLinkJson) {
      deepLinkJson = this._extractDeepLinkJsonFromSpecificNavigationQueryParam();
      if(deepLinkJson) {
        isDeepLinkFromSpecificNavigation = true;
      }
    }


    if(Check.isEmpty(deepLinkJson)) {
      return null;
    }

    try {
      let deepLinkObject: string | null = null;
      if(Check.isString(deepLinkJson)) {
        deepLinkObject = JSON.parse(deepLinkJson);
      } else if(Check.isObject(deepLinkJson)) {
        deepLinkObject = deepLinkJson;
      } else {
        return null;
      }

      if(this._isDeepLinkObject(deepLinkObject)) {
        return new DeepLinkJsonObjectParser(deepLinkObject);
      }

      return null;

    } catch (err) {
      if(isDeepLinkFromSpecificNavigation) {
        this.services.logger.info(`Current route specific navigation doesn't contain a deep link: ${this.services.location.currentUri.toString()}`);
      } else {
        this.services.logger.error(`Failed to parse deep link object from current route ${this.services.location.currentUri.toString()}`);
      }

      return null;
    }
  }


  getParserFromDeepLinkObject(deepLinkObject: any): IDeepLinkParser | null {
    if(this._isDeepLinkObject(deepLinkObject)) {
      return new DeepLinkJsonObjectParser(deepLinkObject);
    }
    return null;
  }

  private _isDeepLinkObject(obj: any): boolean {
    if(!Check.isObject(obj)) {
      return false;
    }

    if(!obj['action']){
      return false;
    }

    return true;
  }

  private _extractDeepLinkJsonFromFragment(): string | null {
    let fragment = this.services.location.currentUri.hash.value;
    if(!fragment) {
      return null;
    }

    fragment = decodeUriComponentRecursive(fragment);

    if(fragment.indexOf(DEEP_LINK_HASH_PARAM) !== 0 && fragment.indexOf(SPECIFIC_NAVIGATION_PARAM) !== 0) {
      return null;
    }

    return fragment.replace(DEEP_LINK_HASH_PARAM, '').replace(SPECIFIC_NAVIGATION_PARAM, '');
  }



  private _extractDeepLinkJsonFromDeepLinkQueryParam(): string | null {
    if (this.services.location.currentUri.queryParams.isEmpty) {
      return null;
    }

    return decodeUriComponentRecursive(this.services.location.currentUri.queryParams.getParamValue(DEEP_LINK_QUERY_PARAM) || '');
  }

  private _extractDeepLinkJsonFromSpecificNavigationQueryParam(): string | null {

    if (this.services.location.currentUri.queryParams.isEmpty) {
      return null;
    }

    return decodeUriComponentRecursive(this.services.location.currentUri.queryParams.getParamValue(SPECIFIC_NAVIGATION) || '');
  }

}
